import { LOADING, LOADING_ERROR, LOADING_SUCCESS, CLEAR_ALL_ERRORS } from './actionTypes'

import unionBy from 'lodash/unionBy'
import filter from 'lodash/filter'
import split from 'lodash/split'
import first from 'lodash/first'
import { defaultErrorMessage } from '@futures-platform/i18n'

const initialState = []

const handleAdd = (state, { component, error, defaultMessage, message }) => unionBy(state, [{
    type: component,
    err: error,
    message: message || defaultErrorMessage(defaultMessage)
}], 'type')

const handleRemove = (state, { component }) => filter(state, ({ type }) => type !== component)

export default (state = initialState, action) => {
    const { type, payload } = action
    const typePrefix = first(split(type, '/'))
    switch (typePrefix) {
        case CLEAR_ALL_ERRORS:
            return initialState
        case LOADING_ERROR:
            return handleAdd(state, payload)
        case LOADING:
        case LOADING_SUCCESS:
            return handleRemove(state, payload)
        default:
            return state
    }
}
